import React, { useState, useEffect } from 'react';
import { Ticket, CreditCard, Smartphone, Check, Info, Shield } from 'lucide-react';
import { ticketsAPI } from '../services/api';
import './Tickets.css';

const Tickets = () => {
  const [ticketTypes, setTicketTypes] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTicketTypes();
  }, []);

  const loadTicketTypes = async () => {
    setLoading(true);
    try {
      const data = await ticketsAPI.getTicketTypes();
      setTicketTypes(data);
    } catch (error) {
      console.error('Error loading ticket types:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePurchase = (ticket) => {
    setSelectedTicket(ticket);
    // Here you would open a payment modal or redirect to checkout
  };

  return (
    <div className="tickets-page">
      <section className="tickets-hero">
        <div className="container">
          <h1 className="page-title">Bilete & Abonamente</h1>
          <p className="page-subtitle">
            Cumpără bilete online simplu și rapid, fără cozi și fără numerar
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="tickets-grid">
            {loading ? (
              <div className="loading-state">Se încarcă tipurile de bilete...</div>
            ) : (
              ticketTypes.map((ticket) => (
                <div key={ticket.id} className="ticket-card card">
                  {ticket.discounted && (
                    <div className="ticket-badge">REDUCERE</div>
                  )}
                  <div className="ticket-icon">
                    <Ticket size={32} />
                  </div>
                  <h3 className="ticket-name">{ticket.name}</h3>
                  <p className="ticket-description">{ticket.description}</p>

                  <div className="ticket-price">
                    <span className="price-label">de la</span>
                    <span className="price-amount">{ticket.price}</span>
                    <span className="price-currency">{ticket.currency}</span>
                  </div>

                  <div className="ticket-validity">
                    <Info size={16} />
                    <span>Preț per cursă efectuată</span>
                  </div>

                  <button
                    className="btn btn-primary"
                    onClick={() => handlePurchase(ticket)}
                  >
                    Descarcă Aplicația
                  </button>
                </div>
              ))
            )}
          </div>

          <div className="payment-methods section">
            <h2 className="section-title">Metode de Plată</h2>
            <div className="payment-grid">
              <div className="payment-method">
                <CreditCard size={32} />
                <h4>Card Bancar</h4>
                <p>Visa, Mastercard</p>
              </div>
              <div className="payment-method">
                <Smartphone size={32} />
                <h4>Apple Pay</h4>
                <p>Plată rapidă iOS</p>
              </div>
              <div className="payment-method">
                <Smartphone size={32} />
                <h4>Google Pay</h4>
                <p>Plată rapidă Android</p>
              </div>
            </div>
          </div>

          <div className="security-notice">
            <Shield size={24} />
            <div>
              <h4>Plăți 100% Securizate</h4>
              <p>Toate tranzacțiile sunt criptate și procesate în siguranță</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tickets;
